import { render } from "./SavoirsEtre.vue?vue&type=template&id=71cab63d&scoped=true"
import script from "./SavoirsEtre.vue?vue&type=script&lang=js"
export * from "./SavoirsEtre.vue?vue&type=script&lang=js"

import "./SavoirsEtre.vue?vue&type=style&index=0&id=71cab63d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cab63d"]])

export default __exports__